import { render, staticRenderFns } from "./DualPage.vue?vue&type=template&id=1a5b2a1d&"
import script from "./DualPage.vue?vue&type=script&lang=js&"
export * from "./DualPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports